import {
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  AfterContentInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';
import { OrgbrainTabDirective } from './orgbrain-tab.directive';

@UntilDestroy()
@Component({
  selector: 'orgbrain-tabs',
  templateUrl: './orgbrain-tabs.component.html',
  styleUrls: ['./orgbrain-tabs.component.scss'],
  standalone: false,
})
export class OrgbrainTabsComponent implements OnInit, AfterContentInit {
  route = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  @ViewChild('tabContainer') tabContainer!: ElementRef;
  @ContentChildren(OrgbrainTabDirective) tabList!: QueryList<OrgbrainTabDirective>;
  @Input() tabId;
  @Input() startTab: number;
  @Input() overrideClass = '';
  @Input() overrideTabClass = 'py-8 position-relative';
  @Output() activeTab = new EventEmitter();
  tabs: OrgbrainTabDirective[] = [];
  selectedTab = 0;

  async ngOnInit() {
    if (typeof this.startTab === 'number') {
      this.selectedTab = this.startTab;
      return;
    }
    if (!this.tabId) return;
    this.selectedTab = parseInt(localStorage.getItem('orgbrain-tab-' + this.tabId)) || 0;

    const params = await firstValueFrom(this.activatedRoute.params);
    if (params.orgbrainTab) {
      this.changeTab(parseInt(params.orgbrainTab));
      this.route.navigate(['..'], {
        relativeTo: this.activatedRoute,
      });
    } else {
      this.emitActiveTab();
    }
  }

  ngAfterContentInit() {
    this.tabs = this.tabList.toArray();
  }

  changeTab(index: number) {
    this.selectedTab = index;

    if (this.tabId) {
      localStorage.setItem('orgbrain-tab-' + this.tabId, index.toString());
    }
    this.emitActiveTab();
  }

  private emitActiveTab() {
    const activeTabId = this.tabs[this.selectedTab]?.id;
    this.activeTab.emit(activeTabId || this.selectedTab);
  }

  isTemplate(label: any): label is TemplateRef<any> {
    return label instanceof TemplateRef;
  }
  scrollLeft() {
    this.scroll(-1);
  }
  scrollRight() {
    this.scroll(1);
  }
  scroll(dir: number) {
    this.tabContainer.nativeElement.scrollBy({
      left: dir * 150,
      behavior: 'smooth',
    });
  }
  isScrollable(): boolean {
    const el = this.tabContainer?.nativeElement as HTMLElement;
    if (!el) {
      return false;
    }
    // add 10 px for label horrible code
    return el.scrollWidth > el.clientWidth + 10;
  }
}
